import { useQuery } from "react-query";
import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { AdminMetricsResponse } from "@circle-react/apps/EoyRecapApp/types";

const FOURTEEN_DAYS = 14 * 24 * 60 * 60 * 1000;

const QUERY_KEY = ["eoy-recap", "metrics", "2025", "admin"];

export const useAdminMetrics = () => {
  const fetchMetrics = (): Promise<AdminMetricsResponse> =>
    reactQueryGet(internalApi.settings.recap.get());

  const {
    data,
    isLoading: isMetricsLoading,
    error: errorFetchingMetrics,
    refetch: refetchMetrics,
  } = useQuery<AdminMetricsResponse, ApiError>(QUERY_KEY, fetchMetrics, {
    staleTime: FOURTEEN_DAYS,
    cacheTime: FOURTEEN_DAYS,
  });

  return {
    metrics: data?.metrics,
    communityMember: data?.community_member,
    isMetricsLoading,
    errorFetchingMetrics,
    refetchMetrics,
  };
};
